export enum FootfallMeasureType {
    NumberOfVisits = "numberOfVisits",
    DwellTime = "dwellTime"
}
